<template>
  <div class="dem-edi-ser-form" :class="demEdiSerFormVerificarTamanho">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="linha-1">
        <App-Autocompletar :data-time="time" class="app-cpnt-field dem-edi-ser-form--item"
          :cpntStatus='campos.item.status'
          :cpntId='campos.item.id'
          :cpntTabIndex='campos.item.tabIndex'
          :cpntNome='campos.item.nome'
          :cpntValue='campos.item.value'
          :cpntMensagem='campos.item.mensagem'
          :cpntMensagemTipo='campos.item.mensagemTipo'
          :cpntDisabled='campos.item.disabled'
          :cpntMostrar='campos.item.mostrar === true'
          :cpntExplica='campos.item.explica'
          :cpntPlaceholder='campos.item.placeholder'
          :cpntValueRef='campos.item.valueRef'
          :cpntRouter='campos.item.router'
          :cpntMethod='campos.item.method'
          :cpntField='campos.item.field'
          :cpntFieldVirtual='campos.item.fieldVirtual'
          :cpntWhere='campos.item.where'
          :cpntAddButForm='campos.item.addButForm'
          :cpntKeyMostra='campos.item.keyMostra'
          :cpntTipoOrder='campos.item.tipoOrder'
          :cpntOrder='campos.item.order'
          :cpntOptions='campos.item.options'
          :cpntKeyValue='campos.item.keyValue'
          :cpntSearchMinimo='campos.item.searchMinimo'
          :cpntMask='campos.item.mask'
          :cpntNewOption='campos.item.newOption'

          :cpntOnChange='campos.item.onChange'
          :cpntOnBlur='campos.item.onBlur'
          :cpntOnRealizaBusca='campos.item.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.item.onKeyPressEnter'
          ref="item"
        ></App-Autocompletar>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-form--qtde"
          :cpntStatus='campos.qtde.status'
          :cpntId='campos.qtde.id'
          :cpntTabIndex='campos.qtde.tabIndex'
          :cpntNome='campos.qtde.nome'
          :cpntValue='campos.qtde.value'
          :cpntMensagem='campos.qtde.mensagem'
          :cpntMensagemTipo='campos.qtde.mensagemTipo'
          :cpntDisabled='campos.qtde.disabled'
          :cpntMostrar='demEdiSerFormMostrarCampos === true && campos.qtde.mostrar === true'
          :cpntExplica='campos.qtde.explica'
          :cpntPlaceholder='campos.qtde.placeholder'
          :cpntValueRef='campos.qtde.valueRef'
          :cpntRouter='campos.qtde.router'
          :cpntField='campos.qtde.field'
          :cpntWhere='campos.qtde.where'
          :cpntAddButForm='campos.qtde.addButForm'
          :cpntKeyMostra='campos.qtde.keyMostra'
          :cpntTipoOrder='campos.qtde.tipoOrder'
          :cpntOrder='campos.qtde.order'
          :cpntOptions='campos.qtde.options'
          :cpntKeyValue='campos.qtde.keyValue'
          :cpntSearchMinimo='campos.qtde.searchMinimo'
          :cpntMask='campos.qtde.mask'

          :cpntOnChange='campos.qtde.onChange'
          :cpntOnBlur='campos.qtde.onBlur'
          :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
          ref="qtde"
        ></App-Input>

        <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-form--valor_uni"
            :cpntStatus='campos.valor_uni.status'
            :cpntId='campos.valor_uni.id'
            :cpntTabIndex='campos.valor_uni.tabIndex'
            :cpntNome='campos.valor_uni.nome'
            :cpntValue='campos.valor_uni.value'
            :cpntMensagem='campos.valor_uni.mensagem'
            :cpntMensagemTipo='campos.valor_uni.mensagemTipo'
            :cpntDisabled='campos.valor_uni.disabled'
            :cpntMostrar='demEdiSerFormMostrarCampos === true && campos.valor_uni.mostrar === true'
            :cpntExplica='campos.valor_uni.explica'
            :cpntPlaceholder='campos.valor_uni.placeholder'
            :cpntValueRef='campos.valor_uni.valueRef'
            :cpntRouter='campos.valor_uni.router'
            :cpntField='campos.valor_uni.field'
            :cpntWhere='campos.valor_uni.where'
            :cpntAddButForm='campos.valor_uni.addButForm'
            :cpntKeyMostra='campos.valor_uni.keyMostra'
            :cpntTipoOrder='campos.valor_uni.tipoOrder'
            :cpntOrder='campos.valor_uni.order'
            :cpntOptions='campos.valor_uni.options'
            :cpntKeyValue='campos.valor_uni.keyValue'
            :cpntSearchMinimo='campos.valor_uni.searchMinimo'
            :cpntMask='campos.valor_uni.mask'

            :cpntOnChange='campos.valor_uni.onChange'
            :cpntOnBlur='campos.valor_uni.onBlur'
            :cpntOnRealizaBusca='campos.valor_uni.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_uni.onKeyPressEnter'
            ref="valor_uni"
          ></App-Input>

          <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-form--valor_uni_por"
            :cpntStatus='campos.valor_uni_por.status'
            :cpntId='campos.valor_uni_por.id'
            :cpntTabIndex='campos.valor_uni_por.tabIndex'
            :cpntNome='campos.valor_uni_por.nome'
            :cpntValue='campos.valor_uni_por.value'
            :cpntMensagem='campos.valor_uni_por.mensagem'
            :cpntMensagemTipo='campos.valor_uni_por.mensagemTipo'
            :cpntDisabled='campos.valor_uni_por.disabled'
            :cpntMostrar='demEdiSerFormMostrarCampos === true && campos.valor_uni_por.mostrar === true'
            :cpntExplica='campos.valor_uni_por.explica'
            :cpntPlaceholder='campos.valor_uni_por.placeholder'
            :cpntValueRef='campos.valor_uni_por.valueRef'
            :cpntRouter='campos.valor_uni_por.router'
            :cpntField='campos.valor_uni_por.field'
            :cpntWhere='campos.valor_uni_por.where'
            :cpntAddButForm='campos.valor_uni_por.addButForm'
            :cpntKeyMostra='campos.valor_uni_por.keyMostra'
            :cpntTipoOrder='campos.valor_uni_por.tipoOrder'
            :cpntOrder='campos.valor_uni_por.order'
            :cpntOptions='campos.valor_uni_por.options'
            :cpntKeyValue='campos.valor_uni_por.keyValue'
            :cpntSearchMinimo='campos.valor_uni_por.searchMinimo'
            :cpntMask='campos.valor_uni_por.mask'

            :cpntOnBuscarOptions='campos.valor_uni_por.onBuscarOptions'
            :cpntOnChange='campos.valor_uni_por.onChange'
            :cpntOnBlur='campos.valor_uni_por.onBlur'
            :cpntOnRealizaBusca='campos.valor_uni_por.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_uni_por.onKeyPressEnter'
            ref="valor_uni_por"
          ></App-Select>
        </template>

        <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-form--cms_com_id"
          :cpntStatus='campos.cms_com_id.status'
          :cpntId='campos.cms_com_id.id'
          :cpntTabIndex='campos.cms_com_id.tabIndex'
          :cpntNome='campos.cms_com_id.nome'
          :cpntValue='campos.cms_com_id.value'
          :cpntMensagem='campos.cms_com_id.mensagem'
          :cpntMensagemTipo='campos.cms_com_id.mensagemTipo'
          :cpntDisabled='campos.cms_com_id.disabled'
          :cpntMostrar='demEdiSerFormMostrarCampos === true && campos.cms_com_id.mostrar === true'
          :cpntExplica='campos.cms_com_id.explica'
          :cpntPlaceholder='campos.cms_com_id.placeholder'
          :cpntValueRef='campos.cms_com_id.valueRef'
          :cpntRouter='campos.cms_com_id.router'
          :cpntField='campos.cms_com_id.field'
          :cpntWhere='campos.cms_com_id.where'
          :cpntAddButForm='campos.cms_com_id.addButForm'
          :cpntKeyMostra='campos.cms_com_id.keyMostra'
          :cpntTipoOrder='campos.cms_com_id.tipoOrder'
          :cpntOrder='campos.cms_com_id.order'
          :cpntOptions='campos.cms_com_id.options'
          :cpntKeyValue='campos.cms_com_id.keyValue'
          :cpntSearchMinimo='campos.cms_com_id.searchMinimo'
          :cpntMask='campos.cms_com_id.mask'

          :cpntOnBuscarOptions='campos.cms_com_id.onBuscarOptions'
          :cpntOnChange='campos.cms_com_id.onChange'
          :cpntOnBlur='campos.cms_com_id.onBlur'
          :cpntOnRealizaBusca='campos.cms_com_id.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.cms_com_id.onKeyPressEnter'
          ref="cms_com_id"
        ></App-Select>

        <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-form--id_pco_status"
          :cpntStatus='campos.id_pco_status.status'
          :cpntId='campos.id_pco_status.id'
          :cpntTabIndex='campos.id_pco_status.tabIndex'
          :cpntNome='campos.id_pco_status.nome'
          :cpntValue='campos.id_pco_status.value'
          :cpntMensagem='campos.id_pco_status.mensagem'
          :cpntMensagemTipo='campos.id_pco_status.mensagemTipo'
          :cpntDisabled='campos.id_pco_status.disabled'
          :cpntMostrar='demEdiSerFormMostrarCampos === true && campos.id_pco_status.mostrar === true'
          :cpntExplica='campos.id_pco_status.explica'
          :cpntPlaceholder='campos.id_pco_status.placeholder'
          :cpntValueRef='campos.id_pco_status.valueRef'
          :cpntRouter='campos.id_pco_status.router'
          :cpntField='campos.id_pco_status.field'
          :cpntWhere='campos.id_pco_status.where'
          :cpntAddButForm='campos.id_pco_status.addButForm'
          :cpntKeyMostra='campos.id_pco_status.keyMostra'
          :cpntTipoOrder='campos.id_pco_status.tipoOrder'
          :cpntOrder='campos.id_pco_status.order'
          :cpntOptions='campos.id_pco_status.options'
          :cpntKeyValue='campos.id_pco_status.keyValue'
          :cpntSearchMinimo='campos.id_pco_status.searchMinimo'
          :cpntMask='campos.id_pco_status.mask'
          :cpntOptionInicialNome='campos.id_pco_status.optionInicialNome'

          :cpntOnChange='campos.id_pco_status.onChange'
          :cpntOnBlur='campos.id_pco_status.onBlur'
          :cpntOnRealizaBusca='campos.id_pco_status.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_pco_status.onKeyPressEnter'
          ref="id_pco_status"
        ></App-Select>
        <!-- :cpntOnBuscarOptions='campos.id_pco_status.onBuscarOptions' -->
      </div>

      <div class="linha-4 botoes" v-show="demEdiSerFormMostrarCampos === true">
        <App-Button :data-time='time'
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='demEdiSerFormMostrarCampos === true'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>

        <App-Button :data-time='time'
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='demEdiSerFormMostrarCampos === true'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .dem-edi-ser-form {
    padding: 8px 12px 13px 12px;
    background: #efefef;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
    max-width: 100%;
  }

  .dem-edi-ser-form.simplificado {
    max-width: 370px;
  }
  .dem-edi-ser-form.completo {
    max-width: 670px;
    text-align: center;
  }
  .dem-edi-ser-form.simplificado > div > .dem-edi-ser-form--item {
    width: 100%;
  }
  .dem-edi-ser-form > div {
    margin-top: -10px;
  }
  .dem-edi-ser-form.completo > div {
    width: calc(100% + 10px);
  }
  .dem-edi-ser-form > div > div {
    margin-right: 10px;
    margin-top: 25px !important;
  }
  .dem-edi-ser-form.completo > div > .dem-edi-ser-form--item {
    width: calc(60% - 10px);
  }

  .dem-edi-ser-form.completo > div > .dem-edi-ser-form--qtde,
  .dem-edi-ser-form.completo > div > .dem-edi-ser-form--valor_uni {
    width: calc(20% - 10px);
  }
  .dem-edi-ser-form.completo > div > .dem-edi-ser-form--valor_uni_por {
    width: calc(40% - 10px);
  }
  .dem-edi-ser-form > div > .dem-edi-ser-form--valor_fre,
  .dem-edi-ser-form > div > .dem-edi-ser-form--valor_seg,
  .dem-edi-ser-form > div > .dem-edi-ser-form--valor_des,
  .dem-edi-ser-form > div > .dem-edi-ser-form--valor_oda {
    width: calc(25% - 10px);
  }
  .dem-edi-ser-form > div > .dem-edi-ser-form--cms_com_id,
  .dem-edi-ser-form > div > .dem-edi-ser-form--xPed,
  .dem-edi-ser-form > div > .dem-edi-ser-form--id_pco_status {
    width: calc(33.3333% - 10px);
  }
  .dem-edi-ser-form > div.botoes {
    width: calc(100%);
    margin-top: 10px;
    text-align: center;
  }
    .dem-edi-ser-form > div.botoes > button {
      margin: 0px 5px;
    }
</style>

<style>
  .dem-edi-ser-form.completo > div > div > label {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    text-align: left;
  }

  .dem-edi-ser-form.completo > div > .dem-edi-ser-form--item > .com-new-option {
    width: 100% !important;
  }
    .dem-edi-ser-form.completo > div > .dem-edi-ser-form--item > .com-new-option ~ button {
      display: none;
    }
    .dem-edi-ser-form.completo > div > .dem-edi-ser-form--item > .com-new-option > div > input {
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
    }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntVendedorDoContato: {
        required: true
      }
    },
    // components: {
    //   'App-Select': () => import('@/components/_geral/Select.vue'),
    //   'App-Input': () => import('@/components/_geral/Input.vue'),
    //   'App-Autocompletar': () => import('@/components/_geral/Autocompletar.vue'),
    // },
    data: function () {
      return {
        time: '',
        statusGeral: '',

        campos: {
          item: {
            id: 'dem-edi-ser-form--item',
            status: '',
            tabIndex: 17030001,
            nome: 'Serviço (DIGITE e SELECIONE)',
            router: '/servico/get',
            method: 'POST',
            field: { id: null, nome: null, id_cat: { j: { nome: null } }, valor: null, tp_valor: null, id_pco_status: { j: { nome: null } } },
            where: 'dem-edi-ser',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', ' - c', 'id' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo servico' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demEdiSerFormOnNovoServico
            },
            apiEnv: 'id_ser',
            value: '',
            valueRef: '',
            mostrar: true,
            onRealizaBusca: this.demEdiSerFormOnRealizarBusca,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          },
          qtde: {
            id: 'dem-edi-ser-form--qtde',
            status: '',
            tabIndex: 17030002,
            nome: 'Quantidade',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'qtde',
            value: '1,00',
            mostrar: true,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          },
          valor_uni: {
            id: 'dem-edi-ser-form--valor_uni',
            status: '',
            tabIndex: 17030003,
            nome: 'Valor Unitário (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_uni',
            value: '0',
            mostrar: true,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          },
          valor_uni_por: {
            id: 'dem-edi-ser-form--valor_uni_por',
            status: '',
            tabIndex: 17030004,
            nome: 'Porcentagem %',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            value: '',
            options: [
              { id: '5'   },
              { id: '10'  },
              { id: '15'  },
              { id: '20'  },
              { id: '25'  },
              { id: '30'  },
              { id: '35'  },
              { id: '40'  },
              { id: '45'  },
              { id: '50'  },
              { id: '55'  },
              { id: '60'  },
              { id: '65'  },
              { id: '70'  },
              { id: '75'  },
              { id: '80'  },
              { id: '85'  },
              { id: '90'  },
              { id: '95'  },
              { id: '100' }
            ],
            mostrar: true,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          },
          cms_com_id: {
            id: 'dem-edi-ser-form--cms_com_id',
            status: '',
            tabIndex: 17030005,
            nome: 'Vendedor',
            keyValue: 'id_con',
            keyMostra: [ 'id_con', ' - ', 'id_con_nome' ],
            options: [],
            value: '',
            apiEnv: 'cms_com_id',
            mostrar: true,
            onBuscarOptions: this.demEdiSerFormOnBuscarVendedores,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          },
          id_pco_status: {
            id: 'dem-edi-ser-form--id_pco_status',
            status: '',
            tabIndex: 17030006,
            nome: 'Lista de processo',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Não utilizar',
            value: '',
            apiEnv: 'id_pco_status',
            mostrar: true,
            //onBuscarOptions: this.demEdiSerFormOnListaPco,
            onChange: this.demEdiSerFormOnChangeValue,
            onKeyPressEnter: this.demEdiSerFormOnKeyPressEnter
          }
        },
        botoes: {
          salvar: {
            status: '',
            tabIndex: 17030040,
            id: 'dem-edi-ser-form--salvar',
            texto: 'Inserir Serviço',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: this.demEdiSerFormInserir
          },
          cancelar: {
            status: '',
            tabIndex: 17030041,
            id: 'dem-edi-ser-form--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: this.demEdiSerFormCancelar
          }
        }
      }
    },
    mounted: function () {
      this.demEdiSerFormIniciar()
    },
    methods: {
      demEdiSerFormIniciar: function () {
        // VERIFICA SE TEM QUE MOSTRAR O CONTROLE DE PROCESSOS
        this.campos.id_pco_status.mostrar = this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true

        // VERIFICA SE TEM CONTROLE DE COMISSÕES
        this.campos.cms_com_id.mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true

        if(this.campos.id_pco_status.mostrar) {

          this.demEdiSerFormOnListaPco()
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerFormSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerFormSetarVendedor: function () {
        // PEGA O VALOR
        var valor = JSON.parse(JSON.stringify(this.cpntVendedorDoContato))

        // SETA O VALOR RECEBIDO
        this.campos.cms_com_id.value = [ '', null, undefined, '0', 0 ].indexOf(valor.id_con) === -1 ? valor : ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerFormOnRealizarBusca: function () {
        // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
        this.campos.item.value = ''
        this.campos.item.valueRef = ''

        // SETA OS VALORES INICIAIS
        this.campos.qtde.value = '1,00'
        this.campos.valor_uni.value = '0'
        this.campos.valor_uni_por.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerFormOnNovoServico: function (nome) {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'servico', id: 0, nome: nome }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.demEdiSerFormOnChangeValue(dados, this.campos.item.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiSerFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE PERSONALIZAR ALGUMA COISA
        switch (index) {
          case 'item':
            // QUEBRA O SINCRONISMO DO VUE
            value = JSON.parse(JSON.stringify(value))

            // SETA O VALOR DO CAMPO
            this.campos[index].value = value
            this.campos[index].valueRef = value.id

            // VERIFICA O CAMPO QUE DEVE MOSTRAR E SETAR O VALOR
            switch (value.tp_valor) {
              case '0':
                // VERIFICA QUAL CAMPO DEVE MOSTRAR
                this.campos.qtde.mostrar = true
                this.campos.valor_uni.mostrar = true
                this.campos.valor_uni_por.mostrar = false

                // SETA O VALOR DE VENDA RECEBIDO DO PRODUTO
                if ([ '', null, undefined ].indexOf(value.valor) === -1) {
                  this.campos.valor_uni.value = value.valor
                }
                break

              case '1':
                // VERIFICA QUAL CAMPO DEVE MOSTRAR
                this.campos.qtde.mostrar = false
                this.campos.valor_uni.mostrar = false
                this.campos.valor_uni_por.mostrar = true

                // SETA O VALOR DE VENDA RECEBIDO DO PRODUTO
                if ([ '', null, undefined ].indexOf(value.valor) === -1) {
                  this.campos.valor_uni_por.value = (value.valor / 100).toString()
                }
                break
            }

            // INICIA O VALOR DO CONTROLE DE PROCESSO DO ITEM
            // var valorPCO = ''

            // VERIFICA SE TEM QUE SETAR A LISTA DE STATUS
            // if ([ '', null, undefined ].indexOf(value.id_pco_status) === -1) {
              // valorPCO = { id: value.id_pco_status, nome: value.id_pco_status_nome }

              // // SETA O VALOR RECEBIDO
              // this.campos.id_pco_status.value = valorPCO
            // } 

            if(this.campos.id_pco_status.value.id === '') {

              // if(this.$store.state.configuracoes.servico.cfg_id_pco_status !== '')
              this.campos.id_pco_status.value = this.$store.state.configuracoes.servico.cfg_id_pco_status

            }            

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA ATUALIZAR O COMISSIONADO
            this.demEdiSerFormSetarVendedor()

            // CHAMA A FUNÇÃO PARA DAR FOCUS NO PROXIMO CAMPO
            this.demEdiSerFormRealizarFocus(index)
            break

          case 'cms_com_id':
            // SETA O VALOR RECEBIDO
            this.campos[index].value = value

            // ATUALIZA O VENDEDOR SELECIONADO
            this.$parent.$emit('DEMANDA_ALTERAR_VENDEDOR', value)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'id_pco_status':
            // SETA O VALOR RECEBIDO
            this.campos[index].value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break
        }
      },
      demEdiSerFormOnKeyPressEnter: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // CHAMA A FUNÇÃO PARA DAR FOCUS NO PROXIMO CAMPO
        this.demEdiSerFormRealizarFocus(index)
      },
      demEdiSerFormFormatarNumeroSalvar: function (valor) {
        // PEGA O VALOR RECEBIDO
        valor = JSON.parse(JSON.stringify(valor)).toString()

        // CONVERTE A VIRGULA EM PONTO
        valor = valor.replace(',', '.')

        // CONVERTE A STRING EM NUMERO
        return valor.toString()
      },
      demEdiSerFormInserir: function () {
        // SETA O STATUS DE CARREGANDO
        this.botoes.salvar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos, this).then((formData) => {
          // SETA O ID DA DEMANDA QUE DEVE SALVAR
          formData.cod_venda = this.cpntDemandaId

          // SETA A ROTA QUE DEVE CHAMAR
          var router = '/venda/servico'

          // VERIFICA O VALOR QUE DEVE PEGAR
          if ([ '', null, undefined ].indexOf(this.campos.item.value) === -1 && [ '', null, undefined ].indexOf(this.campos.item.value.tp_valor) === -1) {
            switch (this.campos.item.value.tp_valor) {
              case '1':
                formData.valor_uni = typeof this.campos.valor_uni_por.value === 'string' ? this.campos.valor_uni_por.value : this.campos.valor_uni_por.value.id
                break

              default:
                formData.valor_uni = this.campos.valor_uni.value
                break
            }
          }

          // VERIFICA SE DEVE MANDAR NULL PARA API
          if ([ '', null, undefined ].indexOf(formData.cms_com_id) !== -1) {
            formData.cms_com_id = null
          }

          // REMOVE O CAMPO SE NÃO TIVER O CAMPO CONTRATADO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === false) {
            delete formData.cms_com_id
          }

          // REMOVE O CAMPO SE NÃO TIVER O CAMPO CONTRATADO
          if ((this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) == false) {
            delete formData.id_pco_status
          }

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
      
                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                  // LIMPA O FORMULARIO
                  this.demEdiSerFormCancelar()
                  
                  // DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })

                // MANDA ATUALIZAR A TABELA
                this.$emit('DEMANDA_UPDATE_TABELA')
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, (campos) => {
                  // SETA OS CAMPOS COM OS ERROS
                  this.campos = campos

                  // SETA O STATUS DA TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })
                break
            }
          }, this.demEdiSerFormSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, this.campos, true, (campos) => {
              // SETA OS CAMPOS COM OS ERROS
              this.campos = campos

              // SETA O STATUS DA TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
            })
          })
        }).catch(this.demEdiSerFormSetarStatusGeral)
      },
      demEdiSerFormCancelar: function () {
        // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
        setTimeout(() => {
          this.campos.item.value = ''
          this.campos.item.valueRef = ''
          this.$refs.item.value = ''
          this.$refs.item.busca = ''
          this.$refs.item.$refs.autocompletar.setValue('')
          this.$refs.item.$refs.autocompletar.$refs.input.value = ''
  
          // SETA OS VALORES INICIAIS
          this.campos.qtde.value = '1,00'

          // SETA O STATUS DE CARREGANDO
          this.botoes.salvar.status = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // SETA O FOCUS NO CAMPO
          setTimeout(() => { this.$refs.item.$refs.autocompletar.$refs.input.select() }, 0)
        }, 0)
      },
      demEdiSerFormRealizarFocus: function (index) {
        switch (index) {
          case 'item':
            this.demEdiSerFormRealizarFocusCampo('qtde')
            break

          case 'qtde':
            this.demEdiSerFormRealizarFocusCampo('valor_uni')
            break

          case 'valor_uni':
            this.demEdiSerFormRealizarFocusCampo('valor_uni_por')
            break

          case 'valor_uni_por':
            this.demEdiSerFormInserir()
            break

          case 'valor_fre':
            this.demEdiSerFormRealizarFocusCampo('valor_seg')
            break

          case 'valor_seg':
            this.demEdiSerFormRealizarFocusCampo('valor_des')
            break

          case 'valor_des':
            this.demEdiSerFormRealizarFocusCampo('valor_oda')
            break

          case 'valor_oda':
            this.demEdiSerFormRealizarFocusCampo('cms_com_id')
            break

          case 'cms_com_id':
            this.demEdiSerFormRealizarFocusCampo('xPed')
            break

          case 'xPed':
            this.demEdiSerFormRealizarFocusCampo('id_pco_status')
            break

          case 'id_pco_status':
            this.demEdiSerFormInserir()
            break
        }
      },
      demEdiSerFormRealizarFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if (this.campos[chave].mostrar === true && [ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.demEdiSerFormRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          } else {
            this.demEdiSerFormRealizarFocus(chave)
          }
        }
      },
      demEdiSerFormOnBuscarVendedores: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id_con: { j: { nome: null } } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/comissao/config/comissionado/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiSerFormOnBuscarVendedores(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.cms_com_id.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.cms_com_id.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiSerFormOnListaPco: function (/*callback, id, */total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { nome: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiSerFormOnListaPco(/*callback, id, */Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_pco_status.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_pco_status.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          // callback()
        }
      },
    },
    computed: {
      demEdiSerFormMostrarCampos: function () {
        return this.campos.item.value !== ''
      },
      demEdiSerFormVerificarTamanho: function () {
        return this.campos.item.valueRef !== '' ? 'completo' : 'simplificado'
      }
    }
  }
</script>
